webpackJsonp([73],{

/***/ 1059:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1060);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(372)("437405a5", content, true, {});

/***/ }),

/***/ 1060:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(371)(true);
// imports


// module
exports.push([module.i, ".underline-loader[data-v-2724d814]{color:#4fb848;font-weight:700;font-size:30px;padding:0 5px 15px 0;background:repeating-linear-gradient(90deg,currentColor 8%,#0000 0 10%) 200% 100%/200% 3px no-repeat;-webkit-animation:c3-data-v-2724d814 2s steps(6) infinite;animation:c3-data-v-2724d814 2s steps(6) infinite}@-webkit-keyframes c3-data-v-2724d814{to{background-position:80% 100%}}@keyframes c3-data-v-2724d814{to{background-position:80% 100%}}", "", {"version":3,"sources":["/app/src/components/payment/credit/redirect.vue"],"names":[],"mappings":"AACA,mCACE,cAAe,AACf,gBAAkB,AAClB,eAAgB,AAChB,qBAAqB,AACrB,qGAAuG,AACvG,0DAA0D,AAClD,iDAAkD,CAC3D,AACD,sCACA,GAAG,4BAA6B,CAC/B,CACA,AACD,8BACA,GAAG,4BAA6B,CAC/B,CACA","file":"redirect.vue","sourcesContent":["\n.underline-loader[data-v-2724d814] {\n  color: #4FB848;\n  font-weight: bold;\n  font-size: 30px;\n  padding:0 5px 15px 0;\n  background:repeating-linear-gradient(90deg,currentColor 0 8%,#0000 0 10%) 200% 100%/200% 3px no-repeat;\n  -webkit-animation:c3-data-v-2724d814 2s steps(6) infinite;\n          animation:c3-data-v-2724d814 2s steps(6) infinite;\n}\n@-webkit-keyframes c3-data-v-2724d814 {\nto{background-position: 80% 100%\n}\n}\n@keyframes c3-data-v-2724d814 {\nto{background-position: 80% 100%\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1061:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.onProcess)?[_c('loader',{attrs:{"content":'Please wait',"visible":_vm.onProcess}})]:[_c('div',{staticClass:"container",staticStyle:{"padding-top":"75px"}},[_c('div',{staticClass:"row text-center"},[(!_vm.paymentSuccess)?[_c('div',{staticClass:"image-failed"}),_vm._v(" "),_c('div',{staticClass:"col-md-8 col-md-offset-2 text-center"},[_c('h3',[_vm._v("Oops! payment failed")]),_vm._v(" "),_c('p',{staticClass:"text-center mb-20"},[_vm._v("\n              You can retry or change your payment method easily on the reservation page.\n            ")]),_vm._v(" "),_c('div',{staticClass:"button-group"},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":("/reservation/inquiry/" + _vm.reservationId)}},[_vm._v("\n                Go to reservation\n              ")])],1)])]:_vm._e()],2)])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 445:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_redirect_vue__ = __webpack_require__(772);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2724d814_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_redirect_vue__ = __webpack_require__(1061);
function injectStyle (ssrContext) {
  __webpack_require__(1059)
}
var normalizeComponent = __webpack_require__(52)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2724d814"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_redirect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2724d814_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_redirect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 518:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/shop/payments';

/* harmony default export */ __webpack_exports__["a"] = ({
  amendPayUrl: function amendPayUrl(url, payload) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://prod-gateway-opsicar.idteknologia.net" + ('/' + url), payload).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  amendPayCredit: function amendPayCredit(param) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/amend/pay/credit?' + param)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  generateUrl: function generateUrl(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/url', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  payWithDeposit: function payWithDeposit(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/deposit', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  payWithInvoice: function payWithInvoice(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/invoice', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  payWithCredit: function payWithCredit(request) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/credit' + request)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt('return', _context6.sent);

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  rdpFirstPhase: function rdpFirstPhase(request) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/reddot/firstphase', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context7.abrupt('return', _context7.sent);

            case 3:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  payPalCaptureOrder: function payPalCaptureOrder(request) {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/paypal/capture', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context8.abrupt('return', _context8.sent);

            case 3:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  }
});

/***/ }),

/***/ 772:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_shop_paymentService_js__ = __webpack_require__(518);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      channel: null,
      reservationId: null,
      onProcess: true,
      countDown: 5, // second
      paymentSuccess: false
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.channel = _this.$route.query.channel;
              _this.reservationId = _this.$route.query.reservation_id;

              if (!(_this.channel && _this.reservationId)) {
                _context.next = 12;
                break;
              }

              if (_this.channel === 'reddotpayment') {
                // await this.payUsingRdp();

                /*
                  for now we use rdp push notify, so, do nothing, just redirect to reservation details .
                  hold 5 second to wait rdp hit maverick
                */
                setTimeout(function () {
                  _this.redirectToRsvDetail();
                }, 5000);
              }

              if (!(_this.channel === 'paypal')) {
                _context.next = 7;
                break;
              }

              _context.next = 7;
              return _this.payUsingPaypal();

            case 7:
              if (!(_this.channel === 'airwallex')) {
                _context.next = 10;
                break;
              }

              _context.next = 10;
              return _this.payUsingAirwallex();

            case 10:
              _context.next = 13;
              break;

            case 12:
              _this.throwNotFound();

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    redirectToRsvDetail: function redirectToRsvDetail() {
      this.$router.push({ path: '/reservation/inquiry/' + this.reservationId });
    },
    throwNotFound: function throwNotFound() {
      this.$router.push({ path: '/404' });
    },
    callPayCheckerApi: function callPayCheckerApi() {
      var _this2 = this;

      var extraParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var queryParams, response, index, _index;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                queryParams = '?channel=' + _this2.channel + extraParams;
                _context2.prev = 1;

                _this2.onProcess = true;
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_2__services_shop_paymentService_js__["a" /* default */].payWithCredit(queryParams);

              case 5:
                response = _context2.sent;


                if (response && response.isSuccess) {
                  _this2.paymentSuccess = response.isSuccess;

                  setTimeout(function () {
                    _this2.onProcess = false;
                    _this2.redirectToRsvDetail();
                  }, 3000);
                } else {
                  _this2.onProcess = false;
                  if (response.errors) {
                    for (index = 0; index < error.errors.length; index++) {
                      _this2.$notification.error(error.errors[index], { title: "Error" });
                    }
                  }
                }
                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](1);

                _this2.onProcess = false;
                if (_context2.t0.errors) {
                  for (_index = 0; _index < _context2.t0.errors.length; _index++) {
                    _this2.$notification.error(_context2.t0.errors[_index], { title: "Error" });
                  }
                }

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 9]]);
      }))();
    },
    payUsingRdp: function payUsingRdp() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var orderId, transactionId, extraParams;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                orderId = _this3.$route.query.order_id;
                transactionId = _this3.$route.query.transaction_id;

                if (!(orderId && transactionId)) {
                  _context3.next = 8;
                  break;
                }

                extraParams = '&orderid=' + orderId + '&transactionid=' + transactionId;
                _context3.next = 6;
                return _this3.callPayCheckerApi(extraParams);

              case 6:
                _context3.next = 9;
                break;

              case 8:
                _this3.throwNotFound();

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    payUsingPaypal: function payUsingPaypal() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var token, extraParams;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                token = _this4.$route.query.token;

                if (!token) {
                  _context4.next = 7;
                  break;
                }

                extraParams = '&token=' + token;
                _context4.next = 5;
                return _this4.callPayCheckerApi(extraParams);

              case 5:
                _context4.next = 8;
                break;

              case 7:
                _this4.throwNotFound();

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    payUsingAirwallex: function payUsingAirwallex() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var paymentIntentId, extraParams, reservationPaymentId, _extraParams;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                paymentIntentId = _this5.$route.query.id;

                if (!paymentIntentId) {
                  _context5.next = 7;
                  break;
                }

                extraParams = '&orderId=' + paymentIntentId;
                _context5.next = 5;
                return _this5.callPayCheckerApi(extraParams);

              case 5:
                _context5.next = 15;
                break;

              case 7:
                reservationPaymentId = _this5.$route.query.reservation_payment_id;

                if (!reservationPaymentId) {
                  _context5.next = 14;
                  break;
                }

                _extraParams = '&reservationPaymentId=' + reservationPaymentId;
                _context5.next = 12;
                return _this5.callPayCheckerApi(_extraParams);

              case 12:
                _context5.next = 15;
                break;

              case 14:
                _this5.throwNotFound();

              case 15:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    countDownTimer: function countDownTimer(reservationId) {
      // if(this.countDown > 0) {
      //   setTimeout(() => {
      //       this.countDown -= 1;
      //       this.countDownTimer(reservationId);
      //   }, 1000);
      // }

      // if (this.countDown === 0) {
      //   this.$router.push({ path: `/reservation/inquiry/${reservationId}` });
      // }
    }
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/73.6cdf4b1654661feeafef.js